import { createFileRoute } from '@tanstack/react-router';
import EmployeeTemplateView from '@features/employee-templates/EmployeeTemplateView';

export const Route = createFileRoute('/w/employee-templates/view/$templateId')({
  staticData: {
    breadcrumb: 'View Template',
    breadcrumbKey: 'K_BREADCRUMB_VIEW_TEMPLATE',
  },
  component: EmployeeTemplateViewPage,
});

function EmployeeTemplateViewPage() {
  const { templateId } = Route.useParams();
  return <EmployeeTemplateView templateId={templateId} />;
}
